var exports = {
  "az": "Box__J7Trz-",
  "HU": "BorderlessTextInput__oISBfV",
  "Jv": "BorderlessTextInput_1__qyOkjq",
};

module.exports = exports;
